<template>
  <div>
    <StepperComponent />
  </div>
</template>

<script>
import StepperComponent from '@/components/StepperForm/StepperForm.vue';
export default {
  name: 'App',
  components: {
    StepperComponent
  }
}
</script>
